/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import Resource from 'linced-app/enums/enrolment-resource';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AttendanceSurveyRoute extends Route {
  queryParams = {
    year: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model() {
    return hash({
      terms: this.store.findAll('term'),
      uploadStatuses: this.store.query('enrolments/status', {
        jurisdiction: Jurisdiction.NZ_MOE,
        resources: [
          Resource.ATTENDANCE_SURVEYS,
          Resource.ATTENDANCE_CORRECTIONS,
        ],
      }),
      surveys: this.store.query('enrolments/attendance-survey', {
        jurisdiction: Jurisdiction.NZ_MOE,
      }),
    });
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.reset();
  }
}
